import { GET_PERMISSIONS } from '../../shared_elements/actionCreators';

const initialState = {
  permission: {},
};

export default function leasesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PERMISSIONS:
      return { ...state, permission: action.payload };
    default:
      return state;
  }
}
